import { roles } from 'features/hoc';

export const mobileUsersRoleRules = {
  menu: { min: roles.admin.value },
  mobileUsers: { min: roles.admin.value },
  merchantReview: { min: roles.admin.value },
};
